import axios, { AxiosInstance, CancelToken } from 'axios';
import get from 'lodash/get';
import config from 'config/Config';
import { initAxios } from 'utils/axios';
import { FetchDailyTeamsCapacityApiResponse } from 'utils/types/dailyTeamsCapacity';

class DailyTeamsCapacityAPI {
  instance: AxiosInstance;
  private includeCognotaResourceServiceHeader: boolean = false;

  constructor() {
    this.instance = initAxios(config.get('backendURL'), 'resourcing');
  }

  fetchDailyTeamsCapacity: (
    url: string,
    cancelToken?: CancelToken
  ) => Promise<FetchDailyTeamsCapacityApiResponse> = async (
    url,
    cancelToken
  ) => {
    const response =
      await this.instance.get<FetchDailyTeamsCapacityApiResponse>(url, {
        cancelToken,
      });
    if (axios.isAxiosError(response)) {
      const errorMessage = get(response, 'response.data.message', '');
      throw errorMessage;
    }
    return response.data;
  };
}

const dailyTeamsCapacityAPI = new DailyTeamsCapacityAPI();
export default dailyTeamsCapacityAPI;
